var _path;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCameraIconDark(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.80002 5.39985C1.80002 4.92246 1.98966 4.46463 2.32723 4.12706C2.66479 3.7895 3.12263 3.59985 3.60002 3.59985H9.00002C9.47741 3.59985 9.93524 3.7895 10.2728 4.12706C10.6104 4.46463 10.8 4.92246 10.8 5.39985V12.5999C10.8 13.0772 10.6104 13.5351 10.2728 13.8726C9.93524 14.2102 9.47741 14.3999 9.00002 14.3999H3.60002C3.12263 14.3999 2.66479 14.2102 2.32723 13.8726C1.98966 13.5351 1.80002 13.0772 1.80002 12.5999V5.39985ZM13.0977 6.39525C12.9482 6.46994 12.8225 6.58477 12.7346 6.72688C12.6467 6.86899 12.6001 7.03276 12.6 7.19985V10.7999C12.6001 10.9669 12.6467 11.1307 12.7346 11.2728C12.8225 11.4149 12.9482 11.5298 13.0977 11.6045L14.8977 12.5045C15.0349 12.573 15.1873 12.6054 15.3405 12.5985C15.4937 12.5916 15.6426 12.5456 15.7731 12.465C15.9035 12.3844 16.0112 12.2718 16.0859 12.1379C16.1607 12.004 16.1999 11.8532 16.2 11.6999V6.29985C16.1999 6.1465 16.1607 5.99571 16.0859 5.8618C16.0112 5.72788 15.9035 5.61528 15.7731 5.53468C15.6426 5.45408 15.4937 5.40814 15.3405 5.40125C15.1873 5.39435 15.0349 5.4267 14.8977 5.49525L13.0977 6.39525Z",
    fill: "#a9a9a9"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraIconDark);
export default __webpack_public_path__ + "static/media/CameraIconDark.edc8e0e1049b8a931aaa88248ba1b771.svg";
export { ForwardRef as ReactComponent };